import { gql } from "@apollo/client";

export const GET_PROVEEDORES = gql`
query QProveedores {
    proveedores
    {
        success,
        error,
        valorEsperado {
            cod_Proveedor,
            nombre,
            cUIT,
            activo,
            domicilio,
            localidad,
            cod_Provincia
        }
    }
}`;

export const GET_DELEGACIONES = gql`
query QGetDelegaciones ($idRegion: Int!) {
    delegaciones (idRegion: $idRegion)
        {
            success,
            error,
            valorEsperado {
                idRegion,
                region,
                idDelegacion,
                descripcion,
                activo,
                cod_Delegacion
            }
        }
}`;

export const GET_APP_PERMISSION = gql`
query QGetPermisoApp ($idApp: Int!, $escritura: Boolean!) {
    permisoApp(idApp: $idApp, escritura: $escritura)
    {
        success,
        error,
        valorEsperado
    }
}`;

export const GET_APP_PERMISSION_BY_NOMBRE = gql`
query QGetPermisoAppByNombre ($nombreApp: String!, $escritura: Boolean!) {
    permisoAppByNombre(nombreApp: $nombreApp, escritura: $escritura)
    {
        success,
        error,
        valorEsperado
    }
}`;